<template lang="pug">
  app-card
    app-card-header
      v-progress-circular(v-if="updating" color="black" size="10" width="2" indeterminate)
      app-indicator(v-else :color="statusColor" size="10")
      span.ml-2(:class="{ 'font-weight-black': sorterKey == 'status' }") 
        b(v-if="letter.mailType") {{ letter.mailType.title}} 
        | (С {{ letter.noticeOrdered ? 'заказным' : 'простым' }} уведомлением) |
        | {{ statusText }}
      v-spacer
      span(:class="{ 'font-weight-black': sorterKey == 'date' }") {{ date }}&emsp;{{ time }}
    app-card-body
      .red--text(v-for="err in errorList" :key="err") {{ err }} 
      app-card-title(v-for="d in docs" :key="d.id" v-line-clamp="1")
        v-icon.mr-2(size="18" color="#314369") description
        | {{ d.name }}
      app-card-caption 
        div(v-if="letter.courtCase") дело № {{ letter.courtCase.number }}, судья: {{ judgeName }}
        div(v-line-clamp="1" :class="{ 'font-weight-black': sorterKey == 'addressee' }") {{ letter.addressee || 'получатель не указан' }},
        div(:class="{ 'font-weight-black': sorterKey == 'address' }") {{ letter.address || 'адрес не указан' }}
        .text-right {{ letter.envelopeFormat ? letter.envelopeFormat.name + ',' : '' }} {{ letter.weight }} гр.
          span(v-if="letter.barCode" v-html="searchShpi(letter)") , {{ letter.barCode }}
          
      
</template>

<script>
import moment from 'moment'
import LetterStatus from './LetterStatus'

export default {
  name: 'letters-card',
  props: {
    letter: Object,
    sorterKey: {
      type: String,
      default: 'date'
    },
    search: String
  },

  computed: {
    errorList () {
      let res = []
      if (this.letter.error) {
        JSON.parse(this.letter.error).errors
        .forEach(error => {
          res.push(...error['error-codes'].map(e => e.description))
        })
      }
      return res
    },

    judgeName () {
      if (this.letter.judge) {
        let judge = this.letter.judge
        let name = judge.lastName + ' ' + (judge.firstName ? judge.firstName.slice(0,1) + '.' : '') + (judge.middleName ? judge.middleName.slice(0,1) + '.' : '') 
        return name
      }
      return null
    },

    statusColor () {
      let { name } = this.letter.status
      return name == LetterStatus.new ? 'blue' : name == LetterStatus.error || name == LetterStatus.communication_error ? 'red' : 'green'
    },

    statusText () {
      switch (this.letter.status.name) {
        case LetterStatus.new: 
          return `документы не распечатаны (${this.letter.sessionDocs.length})`
        case LetterStatus.requested: 
          return 'ожидание ответа от почтового сервера'
        case LetterStatus.awaiting: 
          return 'ожидание конверта'
        case LetterStatus.error: 
          return 'ошибка формирования конверта'
        case LetterStatus.communication_error: 
          return 'ошибка коммуникации'
        default:
          return 'бар-код, конверт и уведомление сформированы'
      }
    },

    date () {
      return moment(this.letter.createDate).format("DD.MM.YYYY")
    },

    time () {
      return moment(this.letter.createDate).format("HH:mm")
    },

    updating () {
      return [LetterStatus.requested, LetterStatus.awaiting].includes(this.letter.status.name)
    },

    docs () {
      let list = [...this.letter.sessionDocs]
      return list.sort((a, b) => a.name.localeCompare(b.name) || b.id - a.id)
    }
  },

  methods: {
    searchShpi (letter) {
      if (!this.search || this.search.length == 0 ) {
        return ", " + letter.barCode
      }
      return ", " + letter.barCode.replace(new RegExp(this.search, "gi"), match => {
        return `<span style="color: #00BCD4; margin: 0px 1px;">${match}</span>`
      })
    },
  }
}
</script>